import * as S from "../ConvenienceTest.style";
import Moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Toggle } from "@fluentui/react";
import {
  DocumentIntelligenceResult,
  DocumentUpload,
} from "../../IntervinentForm/DocumentUpload/DocumentUpload";
import UserIdentitiesService, {
  UserIdentityType,
} from "../../../services/UserIdentitiesService";
import { UserIdentityPersonalData } from "../../IntervinentForm/UserIdentityPersonalData/UserIdentityPersonalData";
import { FiscalAddress } from "../../IntervinentForm/FiscalAddress/FiscalAddress";
import { PostalAddress } from "../../IntervinentForm/PostalAddress/PostalAddress";
import { UserIdentityContactData } from "../../IntervinentForm/UserIdentityContactData.tsx/UserIdentityContactData";
import { Attachment } from "../../Attachment";
import {
  parseAddressToModel,
  setFullNameFunction,
  getIdType,
} from "../../../utils/UserIdentity";
import { IdTypes } from "../../../utils/IdTypes";
import FinametrixService from "../../../services/FinametrixService";
import Auth from "../../../Auth/Auth";
import {
  AUTHORIZATION_CONTINUE_MESSAGE,
  DUPLICATED_ID_DOCUMENT_MESSAGE,
  ERROR_AUTHORIZATION_MESSAGE,
  EXPIRED_DOCUMENT_WARNING_MESSAGE,
  ID_NOT_FOUND_MESSAGE,
  NO_MATCH_DOCUMENT_NUMER_WARNING_MESSAGE,
  PENDING_AUTHORIZATION_MESSAGE,
} from "./AuthorizationConstants";
import React from "react";
import { ClaimMessageData } from "./ClaimMessage/ClaimMessageType";

interface Country {
  key: string;
  text: string;
  value: string;
}
interface IIdTypes {
  key: string;
  text: string;
  value: string;
}

const ConvenienceTestAccountHolderDataInputs = (props: any) => {
  const {
    handleChange,
    handlePostalAddrChange,
    handleIsMinor,
    handleSameAddressChange,
    handleFiscalAddrChange,
    onProcessingDocument,
    updateIntelligenceUserIdentity,
    data,
    formVal,
    setFormVal,
    handleShowAuthorizationWarning,
    isOnlyView,
    userIdentities,
    isNewUserIdentity,
    blockedByAuthorizationWarning,
    handleClaimMessage,
  } = props;

  const {
    birthday,
    idExpiration,
    email = "",
    countryPrefix = "",
    phone,
    operationCountryPrefix,
    operationPhone,
    proofOfMinorGuardianDescription,
    idFront,
    idBack,
    nationalCountry,
    finametrixId,
  } = data;

  // finametrix
  const finametrixIdRef = useRef<string>(finametrixId || null);

  // user
  const user = Auth.getUserProfile();

  // documento cargado
  const [isDocumentLoaded, setIsDocumentLoaded] = useState<boolean>(
    data.idFront !== null && data.idBack !== null
  );
  const currentDate = Moment();
  const isMinorRef = useRef<boolean>(currentDate.diff(birthday!, "years") < 18);

  const [userIdentity, setUserIdentity] = useState<UserIdentityType>(data);
  const [countries, setCountries] = useState<Country[]>([]);
  const [idTypes] = useState<IIdTypes[]>(IdTypes);
  const [isValidIdExpiration, setIsValidIdExpiration] =
    useState<boolean>(false);
  const [fiscalAddressActive, setFiscalAddressActive] =
    useState<boolean>(false);
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    birthday: "",
    email: "",
    countryPrefix: "",
    phone: "",
    operationCountryPrefix: "",
    operationPhone: "",
    proofOfMinorGuardianDescription: "",
    idExpiration: "",
    streetName: "",
    streetNumber: "",
    postal_zipCode: "",
    fiscal_streetName: "",
    fiscal_streetNumber: "",
    fiscal_zipCode: "",
    idType: "",
    birthdayCountry: "",
    nationalCountry: "",
  });

  const [mainFormLocked, setMainFormLocked] = useState<boolean>(true);
  const PERMANENT_DNI_DATE = "1999-01-01";
  const UPDATED_PERMANENT_DNI_DATE = "9999-01-01";

  const getErrorMessage = (field: string, value: any) => {
    switch (field) {
      case "firstName":
        if (value === null || value === undefined || value.length === 0) {
          return <S.Error>El campo Nombre es obligatorio</S.Error>;
        }
        return "";
      case "lastName":
        if (value === null || value === undefined || value.length === 0) {
          return <S.Error>El campo Apellido es obligatorio</S.Error>;
        }
        return "";
      case "birthday":
        if (value === null || value === undefined) {
          return <S.Error>El campo Fecha de nacimiento es obligatorio</S.Error>;
        }
        return null;

      case "email":
        if (value === null || value === undefined) {
          return <S.Error>El campo Correo electrónico es obligatorio</S.Error>;
        }

        if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(value)) {
          return (
            <S.Error>
              El campo Correo electrónico debe tener un formato válido
            </S.Error>
          );
        }
        return "";
      case "countryPrefix":
        return "";
      case "operationCountryPrefix":
        if (value === null || value === undefined) {
          return <S.Error>El campo Prefijo (país) es obligatorio</S.Error>;
        } else {
          return value.length === 0 ? (
            <S.Error>El campo Prefijo (país) es obligatorio</S.Error>
          ) : (
            ""
          );
        }
      case "secondLastName":
      case "streetStair":
      case "streetDoor":
      case "streetFloor":
      case "streetOther":
      case "roadType":
      case "state":
      case "city":
      case "publicPosition":
      case "gafiQuestion":
      case "economicActivity":
      case "proofOfIncome":
      case "maxContribution":
        return "";
      case "operationPhone":
      case "phone":
        if (value === null || value === undefined) {
          return (
            <S.Error>El campo Nº de teléfono móvil es obligatorio</S.Error>
          );
        } else {
          return value.length < 9 ? (
            <S.Error>El campo Nº de teléfono móvil es obligatorio</S.Error>
          ) : (
            ""
          );
        }
      case "idDocument":
        if (value && value.trim().length < 9) {
          return (
            <S.Error className="error">
              El campo Número de documento debe tener al menos 9 caracteres
            </S.Error>
          );
        }
        if (userIdentity.idType === null) {
          userIdentity.idType = "DNI";
        }
        if (value && userIdentity.idType === "DNI") {
          const dniPattern = /^[0-9]{8}[A-Z]$/;
          if (!dniPattern.test(value.trim())) {
            return (
              <S.Error className="error">
                El número de documento no corresponde a un DNI
              </S.Error>
            );
          }
        }
        if (value && userIdentity.idType === "NIE") {
          const niePattern = /^[XYZ][0-9]{7}[A-Z]$/;
          if (!niePattern.test(value.trim())) {
            return (
              <S.Error className="error">
                El número de documento no corresponde a un NIE
              </S.Error>
            );
          }
        }

        return "";

      case "idType":
        return value?.trim().length === 0 ? (
          <S.Error>El campo Tipo de documento es obligatorio</S.Error>
        ) : (
          ""
        );
      case "proofOfMinorGuardianDescription":
        if (value === null || value === undefined) {
          return (
            <S.Error className="error">
              Debe acreditar que es el padre, la madre o el tutor legal del
              menor
            </S.Error>
          );
        } else {
          return isMinorRef.current && value.length === 0 ? (
            <S.Error className="error">
              Debe acreditar que es el padre, la madre o el tutor legal del
              menor
            </S.Error>
          ) : (
            ""
          );
        }
      case "idFront":
      case "idBack":
        return value?.trim().length === 0 ? (
          <S.Error>
            Deben subirse las imágenes del documento identificativo.
          </S.Error>
        ) : (
          ""
        );
      case "postal_streetNumber":
        const isPostalStreetNumberEmpty = !value || value.trim().length === 0;
        if (isPostalStreetNumberEmpty) {
          handleClaimMessage({
            id: field,
            type: "error",
            message: getPlainErrorMessage(field),
          });
        } else {
          handleClaimMessage(null, field); // Elimina el claim si es válido
        }

        return isPostalStreetNumberEmpty ? (
          <S.Error>El campo Número de vía postal es obligatorio</S.Error>
        ) : (
          ""
        );
      case "fiscal_streetNumber":
        return value?.trim().length === 0 ? (
          <S.Error>El campo Número de vía fiscal es obligatorio</S.Error>
        ) : (
          ""
        );
      case "postal_streetName":
        const isPostalStreetNameEmpty = !value || value.trim().length === 0;
        if (isPostalStreetNameEmpty) {
          handleClaimMessage({
            id: field,
            type: "error",
            message: getPlainErrorMessage(field),
          });
        } else {
          handleClaimMessage(null, field); // Elimina el claim
        }
        return isPostalStreetNameEmpty ? (
          <S.Error>El campo Nombre postal de la vía es obligatorio</S.Error>
        ) : (
          ""
        );

      case "fiscal_streetName":
        return value?.trim().length === 0 ? (
          <S.Error>El campo Nombre fiscal de la vía es obligatorio</S.Error>
        ) : (
          ""
        );
      case "zipCode":
        return value?.trim().length === 0 ? (
          <S.Error>El campo código postal es obligatorio</S.Error>
        ) : (
          ""
        );
      case "postal_zipCode":
        const isZipCodeEmpty = !value || value.trim().length === 0;
        if (isZipCodeEmpty) {
          handleClaimMessage({
            id: field,
            type: "error",
            message: getPlainErrorMessage(field),
          });
        } else {
          handleClaimMessage(null, field);
        }

        return isZipCodeEmpty ? (
          <S.Error>El campo Código Postal es obligatorio</S.Error>
        ) : (
          ""
        );
      case "fiscal_zipCode":
        return value?.trim().length === 0 ? (
          <S.Error>
            El campo Código Postal en la dirección fiscal es obligatorio
          </S.Error>
        ) : (
          ""
        );
      case "idExpiration":
        if (value === null || value === undefined) {
          return (
            <S.Error>
              El campo Fecha de validez debe tener un formato válido
            </S.Error>
          );
        }
        if (isMinorRef.current) {
          return "";
        }
        if (!isValidIdExpiration) {
          return <S.Error>La fecha de expiración no es válida</S.Error>;
        }
        return "";

      case "nationalCountry":
        return value?.trim().length === 0 ? (
          <S.Error>El campo nacionalidad es obligatorio</S.Error>
        ) : (
          ""
        );
      default:
        console.error("Error en el switch ", field);
        throw new Error("Error en el switch");
    }
  };

  // INFO: si el id es undefined, bloquea el formulario
  useEffect(() => {
    !!data.id ? setMainFormLocked(false) : setMainFormLocked(true);
  }, [data.id]);

  // INFO: si el idFront o idBack es null, bloquea el formulario => corrige el error de nuevos usuarios
  useEffect(() => {
    idFront === null || idBack === null
      ? setMainFormLocked(true)
      : setMainFormLocked(false);
  }, [idBack, idFront]);

  useEffect(() => {
    FinametrixService.getCountries().then((res) => {
      setCountries(res);
    });
  }, []);

  useEffect(() => {
    if (formVal !== undefined) {
      const currentDate = Moment();
      let isMinor = false;

      if (birthday !== undefined) {
        const birthdayDate = Moment(birthday);
        isMinor = currentDate.diff(birthdayDate, "years") < 18;
        isMinorRef.current = isMinor;
        handleIsMinor(isMinor);
      }

      if (isDocumentLoaded) {
        // Validación zipCode postal
        if (
          userIdentity?.postalAddress?.zipCode &&
          userIdentity.postalAddress.zipCode.trim() !== ""
        ) {
          setFormVal("postal_zipCode", true);
          handleClaimMessage(null, "postal_zipCode");
        } else {
          setFormVal("postal_zipCode", false);
          handleClaimMessage({
            id: "postal_zipCode",
            type: "error",
            message: getPlainErrorMessage("postal_zipCode"),
          });
        }
      }

      // Validación zipCode fiscal si la dirección fiscal está activa
      if (fiscalAddressActive) {
        if (
          userIdentity?.fiscalAddress?.zipCode &&
          userIdentity.fiscalAddress.zipCode.trim() !== ""
        ) {
          setFormVal("fiscal_zipCode", true);
          handleClaimMessage(null, "fiscal_zipCode");
        } else {
          setFormVal("fiscal_zipCode", false);
          setErrors((prevState: any) => ({
            ...prevState,
            fiscal_zipCode: (
              <S.Error>El campo Código Postal es obligatorio.</S.Error>
            ),
          }));
          handleClaimMessage({
            id: "fiscal_zipCode",
            type: "error",
            message: getPlainErrorMessage("fiscal_zipCode"),
          });
        }
      } else {
        setFormVal("fiscal_streetName", true);
        setFormVal("fiscal_streetNumber", true);
        setFormVal("fiscal_zipCode", true);
        handleClaimMessage(null, "fiscal_streetName");
        handleClaimMessage(null, "fiscal_streetNumber");
        handleClaimMessage(null, "fiscal_zipCode");
      }

      if (isDocumentLoaded) {
        Object.keys(data).forEach((key) => {
          if (key in formVal) {
            const value = data[key];
            if (
              key === "proofOfMinorGuardianDescription" &&
              isMinorRef.current
            ) {
              handleClaimMessage({
                id: key,
                type: "error",
                message: getPlainErrorMessage(key),
              });
            }

            if (value === "" || value === null) {
              if (
                (key === "proofOfMinorGuardianDescription" &&
                  !isMinorRef.current) ||
                ([
                  "email",
                  "phone",
                  "operationPhone",
                  "gafiQuestion",
                  "publicPosition",
                  "proofOfIncome",
                  "economicActivity",
                ].includes(key) &&
                  isMinorRef.current)
              ) {
                setFormVal(key, true);
                handleClaimMessage(null, key); // elimina claim si existía
                setErrors((prevState: any) => ({
                  ...prevState,
                  [key]: "",
                }));
              } else {
                setFormVal(key, false);

                const plainError = getPlainErrorMessage(key);

                setErrors((prevState: any) => ({
                  ...prevState,
                  [key]: getErrorMessage(key, value),
                }));

                handleClaimMessage({
                  id: key,
                  type: "error",
                  message: plainError,
                });
              }
            } else {
              const error = getErrorMessage(key, value);

              setErrors((prevState: any) => ({
                ...prevState,
                [key]: error,
              }));

              const hasError =
                error !== null &&
                error !== undefined &&
                (typeof error === "object" ||
                  (typeof error === "string" && error.trim().length > 1));

              if (hasError) {
                const plainError = getPlainErrorMessage(key);
                handleClaimMessage({
                  id: key,
                  type: "error",
                  message: plainError,
                });
              } else {
                handleClaimMessage(null, key);
              }

              setFormVal(key, !hasError);
            }
          }
        });
      }
    }
  }, [data, formVal]);

  const getPlainErrorMessage = (field: string): string => {
    switch (field) {
      case "firstName":
        return "El campo Nombre es obligatorio";
      case "lastName":
        return "El campo Apellido es obligatorio";
      case "email":
        return "El campo Correo electrónico es obligatorio";
      case "operationCountryPrefix":
        return "El campo Prefijo del país (operación) es obligatorio";
      case "countryPrefix":
        return "El campo Prefijo del país es obligatorio";
      case "operationPhone":
        return "El campo Teléfono de operación es obligatorio";
      case "phone":
        return "El campo Teléfono es obligatorio";
      case "birthday":
        return "El campo Fecha de nacimiento es obligatorio";
      case "idDocument":
        return "El campo Número de documento es obligatorio";
      case "proofOfMinorGuardianDescription":
        return "Debe acreditar que es padre, madre o tutor legal del menor";
      case "postal_streetName":
      case "streetName":
      case "postalAddress":
        return "El campo Nombre de la vía postal es obligatorio";
      case "postal_streetNumber":
      case "streetNumber":
        return "El campo Número de vía postal es obligatorio";
      case "postal_zipCode":
        return "El campo Código Postal postal es obligatorio";
      case "idExpiration":
        return "El campo Fecha de validez es obligatorio";
      case "nationalCountry":
        return "El campo Nacionalidad es obligatorio";
      case "fiscal_streetName":
        return "El campo Nombre de la vía fiscal es obligatorio";
      case "fiscal_streetNumber":
        return "El campo Número de vía fiscal es obligatorio";
      case "fiscal_zipCode":
        return "El campo Código Postal fiscal es obligatorio";
      case "idFront":
        return "Debe subir la imagen frontal del documento";
      case "idBack":
        return "Debe subir la imagen trasera del documento";
      case "financialData":
        return "El campo Datos financieros es obligatorio";
      case "maxContribution":
        if (isMinorRef.current) {
          setFormVal("maxContribution", true);
          return "";
        }
        return "El campo Aportación máxima justificada es obligatorio";

      default:
        console.error("Error en el switch de mensajes de error", field);
        return "Hay campos obligatorios sin completar";
    }
  };

  const extractTextFromJSX = (jsx: any): string => {
    if (typeof jsx === "string") return jsx;
    if (!jsx || !jsx.props || !jsx.props.children) return "";
    return typeof jsx.props.children === "string"
      ? jsx.props.children
      : Array.isArray(jsx.props.children)
      ? jsx.props.children.join("")
      : "";
  };

  const handleInputChange = (event: any) => {
    if (event.target !== undefined) {
      var { name, value } = event.target;

      // Actualizar userIdentity
      setUserIdentity((prevState) => ({
        ...prevState,
        [name]: value,
      }));

      var error = getErrorMessage(name, value);

      setErrors((prevState: any) => {
        return {
          ...prevState,
          [name]: error,
        };
      });

      setFormVal(name, error === "");
      handleChange(event);
    }
  };

  const handlePostalAddressChange = (event: any) => {
    const { name, value } = event.target;
    const realName = name.startsWith("postal_") ? name.slice(7) : name;

    // Actualizar postalAddress en userIdentity
    setUserIdentity((prevState) => ({
      ...prevState,
      postalAddress: {
        ...prevState.postalAddress,
        [realName]: value,
      },
    }));

    // Validar errores
    const error = getErrorMessage(name, value);
    setErrors((prevState: any) => ({
      ...prevState,
      [name]: error,
    }));

    const errorText = extractTextFromJSX(error);

    setFormVal(name, error === "");
    handlePostalAddrChange(event);
  };

  const handlePostalAddressInputChange = (event: any) => {
    if (event.target !== undefined) {
      var { name, value } = event.target;
      const realName = name.startsWith("postal_") ? name.slice(7) : name;

      // Actualizar PostalAddress userIdentity
      setUserIdentity((prevState) => ({
        ...prevState,
        postalAddress: {
          ...prevState.postalAddress,
          [realName]: value,
        },
      }));

      if (name === "postal_city" || name === "postal_state") {
        setUserIdentity((prevState) => ({
          ...prevState,
          postalAddress: {
            ...prevState.postalAddress,
            zipCode: "",
          },
        }));
        setFormVal("postal_zipCode", false);
      }

      if (name === "postal_zipCode") {
        const error = getErrorMessage(name, value);
        setErrors((prevState: any) => ({
          ...prevState,
          [name]: error,
        }));
        setFormVal(name, error === "");
      }
      handlePostalAddrChange(event);
    }
  };

  const handlePersonalDataInputChange = (event: any) => {
    if (event.target !== undefined) {
      var { name, value } = event.target;

      setUserIdentity((prevState) => ({
        ...prevState,
        [name]: value,
      }));

      if (name === "nationalCountry") {
        const error = getErrorMessage(name, value);
        setErrors((prevState: any) => ({
          ...prevState,
          [name]: error,
        }));
        setFormVal(name, error === "");
      }
      handleChange(event);
    }
  };

  const handleFiscalAddressInputChange = (event: any) => {
    if (event.target !== undefined) {
      var { name, value } = event.target;
      const realName = name.startsWith("fiscal_") ? name.slice(7) : name;

      // Actualizar PostalAddress userIdentity
      setUserIdentity((prevState) => ({
        ...prevState,
        fiscalAddress: {
          ...prevState.fiscalAddress,
          [realName]: value,
        },
      }));

      if (name === "fiscal_city" || name === "fiscal_state") {
        setUserIdentity((prevState) => ({
          ...prevState,
          fiscalAddress: {
            ...prevState.fiscalAddress,
            zipCode: "",
          },
        }));
        setFormVal("fiscal_zipCode", false);
      }

      // debugger;
      if (name === "fiscal_zipCode" || name === "zipCode") {
        const error = getErrorMessage(name, value);
        setErrors((prevState: any) => ({
          ...prevState,
          [name]: error,
        }));
        setFormVal(name, error === "");
      }
      handleFiscalAddrChange(event);
    }
  };

  const resetErrors = () => {
    setErrors({
      firstName: "",
      lastName: "",
      birthday: "",
      email: "",
      countryPrefix: "",
      phone: "",
      operationCountryPrefix: "",
      operationPhone: "",
      proofOfMinorGuardianDescription: "",
      idExpiration: "",
      streetName: "",
      streetNumber: "",
      postal_zipCode: "",
      idType: "",
      birthdayCountry: "",
      nationalCountry: "",
      fiscal_streetName: "",
      fiscal_streetNumber: "",
      fiscal_zipCode: "",
    });
  };

  // INFO: cambia el estado del toggle y envía el evento al padre
  const handleToggleSameAddressChange = (
    event: React.MouseEvent<HTMLElement>,
    checked?: boolean | null
  ) => {
    setUserIdentity((prevState) => ({
      ...prevState,
      sameAddress: !checked,
    }));
    handleSameAddressChange(event, checked);
    setFiscalAddressActive(!checked ? false : true);
  };

  const handleSelectChange = (name: string, value: string) => {
    handleInputChange({
      target: { name, value },
    } as React.ChangeEvent<HTMLInputElement>);
  };

  const handlePostalAddressSelectChange = (name: string, value: string) => {
    handlePostalAddressInputChange({
      target: { name, value },
    } as React.ChangeEvent<HTMLInputElement>);
  };
  const handleFiscalAddressSelectChange = (name: string, value: string) => {
    handleFiscalAddressInputChange({
      target: { name, value },
    } as React.ChangeEvent<HTMLInputElement>);
  };

  const handlePersonalDataSelectChange = (name: string, value: string) => {
    handlePersonalDataInputChange({
      target: { name, value },
    } as React.ChangeEvent<HTMLInputElement>);
  };

  const handleFiscalAddressChange = (event: any) => {
    const { name, value } = event.target;
    const realName = name.startsWith("fiscal_") ? name.slice(7) : name;
    setUserIdentity((prevState) => ({
      ...prevState,
      fiscalAddress: {
        ...prevState.fiscalAddress,
        [realName]: value,
      },
    }));
    // Validar errores
    const error = getErrorMessage(name, value);
    setErrors((prevState: any) => ({
      ...prevState,
      [name]: error,
    }));
    setFormVal(name, error === "");
    handleFiscalAddrChange(event);
  };

  const handleShouldMainFormLock = (value: boolean) => {
    if (value) {
      resetErrors();
    }
    setMainFormLocked(value);
  };
  const validateInitialIdExpiration = (expirationDate: string | undefined) => {
    if (!expirationDate) {
      setIsValidIdExpiration(false);
      setFormVal("idExpiration", false);
      handleClaimMessage(null, "idExpiration");
      return;
    }
    const idDocumentExpiration = Moment(expirationDate).format("YYYY-MM-DD");
    const today = Moment().format("YYYY-MM-DD");

    // validación Id permanente
    if (idDocumentExpiration === PERMANENT_DNI_DATE) {
      setIsValidIdExpiration(true);
      setFormVal("idExpiration", true);
      setErrors((prevState) => ({
        ...prevState,
        idExpiration: "",
      }));
      handleClaimMessage(null, "idExpiration");
      setUserIdentity((prevState) => ({
        ...prevState,
        idExpiration: Moment(UPDATED_PERMANENT_DNI_DATE).toDate(),
      }));
      return;
    }

    // validación menores
    if (isMinorRef.current) {
      setFormVal("idExpiration", true);
      setFormVal("financialData", true);
      setFormVal("proofOfMinorGuardianDescription", false);
      setIsValidIdExpiration(true);
      return;
    }

    // validación por fecha
    if (Moment(idDocumentExpiration).isBefore(today)) {
      setIsValidIdExpiration(false);
      setFormVal("idExpiration", false);
      setIsValidIdExpiration(false);
      handleClaimMessage({
        id: "idExpiration",
        type: "error",
        message: EXPIRED_DOCUMENT_WARNING_MESSAGE,
      });
    } else {
      setIsValidIdExpiration(true);
      setFormVal("idExpiration", true);
      setErrors((prevState) => ({
        ...prevState,
        idExpiration: "",
      }));
      handleClaimMessage(null, "idExpiration");
    }
  };

  useEffect(() => {
    if (idExpiration !== undefined && idExpiration !== null) {
      validateInitialIdExpiration(idExpiration);
    }
  }, [idExpiration]);

  const handleDateInputChange = (name: string, value: any) => {
    if (value !== undefined) {
      var error = getErrorMessage(name, value);
      setErrors((prevState: any) => {
        return {
          ...prevState,
          [name]: error,
        };
      });

      setFormVal(name, error === "");
      handleChange({ target: { name: name, value: value, files: null } });
      // Lógica específica de la fecha
      const currentDate = Moment();
      let birthdayDate = Moment(birthday);
      if (name === "birthday") {
        birthdayDate = Moment(value);
        setUserIdentity((prevState) => ({
          ...prevState,
          birthday: birthdayDate.toDate(),
        }));
      }

      if (name === "idExpiration") {
        validateInitialIdExpiration(value);
        setUserIdentity((prevState) => ({
          ...prevState,
          idExpiration: Moment(value).toDate(),
        }));
      }

      var isLocalMinor = currentDate.diff(birthdayDate, "years") < 18;
      if (isLocalMinor) {
        var newError =
          proofOfMinorGuardianDescription === null ||
          proofOfMinorGuardianDescription === undefined ||
          proofOfMinorGuardianDescription.length === 0 ? (
            <S.Error className="error">
              Debe acreditar que es el padre, la madre o el tutor legal del
              menor
            </S.Error>
          ) : (
            ""
          );

        setErrors((prevState: any) => {
          return {
            ...prevState,
            email: "",
            countryPrefix: "",
            phone: "",
            operationCountryPrefix: "",
            operationPhone: "",
            idDocument: "",
            idExpiration: "",
            proofOfMinorGuardianDescription: newError,
          };
        });
        setFormVal("email", true);
        setFormVal("countryPrefix", true);
        setFormVal("phone", true);
        setFormVal("operationCountryPrefix", true);
        setFormVal("operationPhone", true);
        setFormVal("proofOfMinorGuardianDescription", false);
        setFormVal("minorTitular", true);
        setFormVal("birthday", true);
        setFormVal("postal_zipCode", true);
        if (fiscalAddressActive) {
          setFormVal("fiscal_zipCode", true);
        } else {
          setFormVal("fiscal_zipCode", false);
        }
        setFormVal("idExpiration", true);
        setFormVal("nationalCountry", true);
      } else {
        setErrors((prevState: any) => {
          return {
            ...prevState,
            email: getErrorMessage("email", email),
            countryPrefix: getErrorMessage("countryPrefix", countryPrefix),
            phone: getErrorMessage("phone", phone),
            operationCountryPrefix: getErrorMessage(
              "operationCountryPrefix",
              operationCountryPrefix
            ),
            operationPhone: getErrorMessage("operationPhone", operationPhone),
            idExpiration: getErrorMessage("idExpiration", idExpiration),
            nationalCountry: getErrorMessage(
              "nationalCountry",
              nationalCountry
            ),
          };
        });
        setFormVal("email", getErrorMessage("email", email) === "");
        setFormVal(
          "postal_zipCode",
          getErrorMessage("postal_zipCode", data.postalAddress?.zipCode!) === ""
        );
        setFormVal(
          "countryPrefix",
          getErrorMessage("countryPrefix", countryPrefix) === ""
        );
        setFormVal("phone", getErrorMessage("phone", phone) === "");
        setFormVal(
          "operationCountryPrefix",
          getErrorMessage("operationCountryPrefix", operationCountryPrefix) ===
            ""
        );
        setFormVal(
          "operationPhone",
          getErrorMessage("operationPhone", operationPhone) === ""
        );
        setFormVal(
          "proofOfMinorGuardianDescription",
          proofOfMinorGuardianDescription === ""
        );
        setFormVal("minorTitular", true);
        setFormVal("birthday", true);
        setFormVal(
          "idExpiration",
          getErrorMessage("idExpiration", idExpiration) === ""
        );
        setFormVal(
          "nationalCountry",
          getErrorMessage("nationalCountry", nationalCountry) === ""
        );

        setFormVal(
          "fiscal_zipCode",
          getErrorMessage("fiscal_zipCode", data.fiscalAddress?.zipCode!) === ""
        );
        setFormVal("idFront", getErrorMessage("idFront", data.idFront!) === "");
        setFormVal("idBack", getErrorMessage("idBack", data.idFront!) === "");
      }
    }
  };

  // resetear errores de la solicitud de acceso
  const resetAccessRequestErrors = () => {
    handleShowAuthorizationWarning(false, null, "", false);
  };

  const handleUploadDocumentResult = async (
    result: DocumentIntelligenceResult
  ) => {
    // mensaje ok!
    setMainFormLocked(true);

    console.log("MI USERIDENTITY ", userIdentity);
    // Si el interviniente no existe en nuestra base de datos, consulta a Finametrix para obtener el FinametrixId del cliente por el número de documento
    if (!userIdentity.id || !userIdentity.finametrixId) {
      try {
        const finametrixClientByIdDocument =
          await FinametrixService.getClientByIdCardNoValidation(
            result.documentNumber
          );
        if (finametrixClientByIdDocument && finametrixClientByIdDocument._id) {
          finametrixIdRef.current = finametrixClientByIdDocument._id;
        }
      } catch (error: any) {
        console.error("Error consultando Finametrix:", error);
      }
    }

    // TODO-hector: ACCESS-REQUEST Comprobar autorización
    const resultCheckIdDocument = await idDocumentExists(
      result.documentNumber,
      result.dateOfExpiration
    );

    setIsDocumentLoaded(true);

    const direc = parseAddressToModel(result.address);
    const fullName = setFullNameFunction({
      firstName: result.firstName,
      lastName: result.lastName,
      secondLastName: result.secondLastName,
    });

    const updatedData = {
      firstName: fullName.firstName,
      lastName: fullName.lastName,
      secondLastName: fullName.secondLastName,
      birthday: new Date(result.dateOfBirth),
      birthdayCountry:
        result.placeOfBirth && result.placeOfBirth.length === 2
          ? result.placeOfBirth
          : "ES",
      nationalCountry:
        result.countryRegion && result.countryRegion.length === 2
          ? result.countryRegion
          : "ES",
      finametrixId: finametrixIdRef.current,
      idExpiration: validateIdExpiration(new Date(result.dateOfExpiration)),
      idDocument: result.documentNumber,
      idType: getIdType(result.documentType, result.countryRegion),
      idFront: result.fileNames[0],
      idBack: result.fileNames[1],
      postalAddress: {
        streetName: direc.streetName,
        roadType: direc.roadType === "C." ? "CL" : direc.roadType,
        streetNumber: direc.streetNumber,
        streetFloor: direc.streetFloor,
        streetStair: direc.streetStair,
        streetDoor: direc.streetDoor,
        streetOther: direc.streetOther,
        city: direc.city,
        zipCode: direc.zipCode,
        state: direc.state,
        country: direc.country === "" ? "ES" : direc.country,
      },
      sameAddress: true,
    };

    setUserIdentity((prevState) => ({
      ...prevState,
      ...updatedData,
    }));

    // updateIntelligenceUserIdentity(updatedData);
    // TODO-hector: ACCESS-REQUEST
    if (resultCheckIdDocument) {
      // Actualización de datos en userIdentity si se cumplen las condiciones para el idDocument leído por documentIntelligence
      updateIntelligenceUserIdentity(updatedData);
    }
  };

  /**
   * autorización :: Comprueba que el DNI no exista en la BBDD para iniciar el proceso de autorización
   * @param idDocument :: número de documento de identidad introducido en el formulario de DocumentIntelligence
   * @returns boolean :: true si el documento ya existe en la BBDD, false si no existe. Se usa para bloquear el formulario
   */
  const idDocumentExists = async (
    idDocument: string,
    dateOfExpration: string
  ): Promise<boolean> => {
    // debugger;
    // console.group('**idDocumentExists**');
    // console.log('**isNewUserIdentity >>> ', isNewUserIdentity);
    // console.log('**isOnlyView >>> ', isOnlyView);
    // console.log('**userIdentity >>> ', userIdentity);
    // console.log('**userIdentities >>> ', userIdentities);
    // console.log('**idDocument >>> ', idDocument);
    // console.groupEnd();

    setMainFormLocked(true); // Bloquear formulario al inicio

    try {
      // Paso 1: Comprobar que el DNI no está caducado
      const expirationDate = validateIdExpiration(new Date(dateOfExpration));
      if (!expirationDate) {
        handleShowAuthorizationWarning(
          true,
          null,
          EXPIRED_DOCUMENT_WARNING_MESSAGE,
          false
        );
        setMainFormLocked(true);
        return false;
      }

      // Paso 2: En edición, si el documento no cambia, permitimos continuar
      if (!isNewUserIdentity && idDocument === userIdentity.idDocument) {
        handleShowAuthorizationWarning(false, null, "", false);
        setMainFormLocked(false);
        return true;
      }

      // Paso 3: Edición + cambio de DNI no válido ::  bloqueamos
      // Solo para edición de interviniente cuando el DNI no es NULL que es el caso de "Completar Datos" de un nuevo usuario
      if (
        !isOnlyView &&
        !isNewUserIdentity &&
        userIdentity.idDocument != null &&
        userIdentity.idDocument !== idDocument
      ) {
        handleShowAuthorizationWarning(
          true,
          null,
          NO_MATCH_DOCUMENT_NUMER_WARNING_MESSAGE,
          false
        );
        setMainFormLocked(true);
        return false;
      }

      // Paso 4: Alta de nuevo userIdentity
      if (isNewUserIdentity) {
        try {
          // 4a. Obtener DNI de bbdd
          const userIdentityByIdDocument: UserIdentityType =
            await UserIdentitiesService.getUSerIdentityByIdDocument(idDocument);

          if (userIdentityByIdDocument?.id) {
            // Existe DNI, comprueba solicitudes de acceso
            const accessRequestResponse =
              await UserIdentitiesService.getAllAccessRequestsByUserId(user.id);

            if (
              accessRequestResponse.status === 200 &&
              accessRequestResponse.count > 0
            ) {
              const matchingRequest = accessRequestResponse.data.find(
                (r) => r.targetUserIdentity?.id === userIdentityByIdDocument.id
              );
              if (matchingRequest) {
                // Solicitud pendiente => Bloqueo de formulario
                handleShowAuthorizationWarning(
                  true,
                  userIdentityByIdDocument,
                  PENDING_AUTHORIZATION_MESSAGE,
                  false
                );
                setMainFormLocked(true);
                return false;
              } else {
                // Existen solicitudes pero no para este DNI >>> aviso y permitir continuar
                handleShowAuthorizationWarning(
                  true,
                  userIdentityByIdDocument,
                  AUTHORIZATION_CONTINUE_MESSAGE,
                  true
                );
                setMainFormLocked(blockedByAuthorizationWarning);
                return true;
              }
            }
            if (accessRequestResponse.status === 400) {
              // Sin solicitudes pendientes >>> aviso y permitir continuar
              handleShowAuthorizationWarning(
                true,
                userIdentityByIdDocument,
                AUTHORIZATION_CONTINUE_MESSAGE,
                true
              );
              setMainFormLocked(blockedByAuthorizationWarning);
              return true;
            }

            // Si llega aquí, está duplicado sin solicitudes >>> bloquear
            handleShowAuthorizationWarning(
              true,
              userIdentityByIdDocument,
              DUPLICATED_ID_DOCUMENT_MESSAGE,
              false
            );
            setMainFormLocked(true);
            return false;
          }
        } catch (error: any) {
          // Aquí capturamos el 404 de tu backend: DNI no existe en tu base → seguimos con Finametrix
          if (error?.response?.status === 404) {
            console.log(
              "DNI no encontrado en nuestra base, comprobando en Finametrix..."
            );
            setMainFormLocked(true);
            try {
              const finametrixClient =
                await FinametrixService.getClientByIdCardNoValidation(
                  idDocument
                );
              if (finametrixClient && finametrixClient._id) {
                console.log(
                  "Cliente encontrado en Finametrix:",
                  finametrixClient
                );
                // Cliente existe en Finametrix >>> asociar finametrixId
                setUserIdentity((prev) => ({
                  ...prev,
                  finametrixId: finametrixClient._id,
                }));
              } else {
                // Si no existe en Finametrix, permitimos el alta
                console.log(
                  "Cliente no encontrado en Finametrix, permitiendo alta sin id"
                );
              }
              // En cualquier caso (existe o no en Finametrix), permitimos el alta
              handleShowAuthorizationWarning(false, null, "", false);
              setMainFormLocked(false);
              return true;
            } catch (finametrixError) {
              // Si la llamada a Finametrix falla, bloqueo por seguridad
              handleShowAuthorizationWarning(
                true,
                null,
                ID_NOT_FOUND_MESSAGE,
                false
              );
              console.error("Error consultando Finametrix:", finametrixError);
              setMainFormLocked(false);
              return true;
            }
          }

          // Cualquier otro error inesperado >>> bloqueo
          handleShowAuthorizationWarning(false, null, "", false);
          setMainFormLocked(false);
          console.error("Error verificando idDocument en alta:", error);
          return true;
        }
      } else {
        // debugger;
        if (userIdentity.idDocument == null) {
          handleShowAuthorizationWarning(false, null, "", false);
          setMainFormLocked(false);
          return true;
        }
      }

      // Paso 5: Edición (no solo vista) >>> validar que el nuevo DNI esté en userIdentities
      const matchByDocumentNumber = userIdentities.some(
        (ui: UserIdentityType) => ui.idDocument === idDocument
      );
      if (!isOnlyView && !isNewUserIdentity && !matchByDocumentNumber) {
        handleShowAuthorizationWarning(
          true,
          null,
          NO_MATCH_DOCUMENT_NUMER_WARNING_MESSAGE,
          false
        );
        setMainFormLocked(true);
        return false;
      }

      // Si no hay motivo de bloqueo, permitimos continuar
      handleShowAuthorizationWarning(false, null, "", false);
      setMainFormLocked(false);
      return true;
    } catch (error: any) {
      // Caso raro: error fuera de los anteriores >>> bloquear el formulario
      handleShowAuthorizationWarning(
        true,
        null,
        ERROR_AUTHORIZATION_MESSAGE,
        false
      );
      setMainFormLocked(true);
      console.error("Error general verificando idDocument:", error);
      return false;
    }
  };

  function boolValidateIdExpiration(idExpiration: Date) {
    const today = new Date();
    const idExpirationDateOnly = new Date(
      idExpiration.getFullYear(),
      idExpiration.getMonth(),
      idExpiration.getDate()
    );
    const todayDateOnly = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    if (idExpirationDateOnly < todayDateOnly) {
      return false;
    } else {
      return true;
    }
  }

  const handleOnProcessingDocument = (isProcessing: boolean) => {
    if (isProcessing) {
      // bloqueo del botón de Guardar
      onProcessingDocument(true);
    }
  };

  const onCreateClaimMessage = (
    claim: ClaimMessageData | null,
    idToRemove?: string
  ) => {
    handleClaimMessage(claim, idToRemove);
  };

  function validateIdExpiration(idExpiration: Date) {
    const isValid = boolValidateIdExpiration(idExpiration);
    setIsValidIdExpiration(isValid);
    return new Date(idExpiration);
  }

  return (
    <>
      <div className="documents-form-container">
        {/* Subida de documentos DocumentIntelligence */}
        <DocumentUpload
          onResetAccessRequestErrors={resetAccessRequestErrors}
          isOnlyView={isOnlyView}
          onProcessingDocument={handleOnProcessingDocument}
          blockedByAuthorizationWarning={blockedByAuthorizationWarning}
          userIdentity={userIdentity}
          userId={userIdentity?.userId!}
          onUpload={handleUploadDocumentResult}
          shouldLockMainForm={handleShouldMainFormLock}
          idFront={idFront}
          idBack={idBack}
          handleCreateClaimMessage={onCreateClaimMessage}
        />

        {/* Datos personales */}
        <UserIdentityPersonalData
          userIdentityData={userIdentity}
          handleInputChange={handleInputChange}
          handleDateInputChange={handleDateInputChange}
          handlePersonalDataSelectChange={handlePersonalDataSelectChange}
          handleChange={handleChange}
          disabled={
            mainFormLocked || isOnlyView || blockedByAuthorizationWarning
          }
          idTypes={idTypes}
          countries={countries}
          errors={errors}
        />

        {/* proofOfMinorGuardianDescription */}
        <S.FielSet>
          {isMinorRef.current && (
            <S.ExtendedFieldFileIsMinorCont>
              <label className="inline">
                Documento que acredite que usted es el tutor legal del menor *
              </label>
              <S.FileInput
                id={"proofOfMinorGuardianDescription"}
                name={"proofOfMinorGuardianDescription"}
                type="file"
                disabled={
                  mainFormLocked || isOnlyView || blockedByAuthorizationWarning
                }
                onChange={handleInputChange}
              />
              {proofOfMinorGuardianDescription !== undefined &&
                typeof proofOfMinorGuardianDescription === "string" && (
                  <div>
                    <Attachment
                      fileName={proofOfMinorGuardianDescription}
                      className="image-preview"
                    />
                  </div>
                )}
              {errors.proofOfMinorGuardianDescription !== "" &&
                errors.proofOfMinorGuardianDescription}
            </S.ExtendedFieldFileIsMinorCont>
          )}
        </S.FielSet>

        {/* Datos de contacto */}
        {!isMinorRef.current && (
          <UserIdentityContactData
            userIdentityData={userIdentity}
            handleInputChange={handleInputChange}
            handleSelectChange={handleSelectChange}
            handleDateInputChange={handleDateInputChange}
            disabled={
              mainFormLocked || isOnlyView || blockedByAuthorizationWarning
            }
            errors={errors}
          />
        )}

        {/* Dirección Postal */}
        <PostalAddress
          userIdentityData={userIdentity}
          handleAddressChange={handlePostalAddressChange}
          handleAddressSelectChange={handlePostalAddressSelectChange}
          disabled={
            mainFormLocked || isOnlyView || blockedByAuthorizationWarning
          }
          errors={errors}
          countries={countries}
        />
        <br />
        <br />

        {/* Dirección Fiscal */}
        <Toggle
          checked={fiscalAddressActive}
          disabled={
            mainFormLocked || isOnlyView || blockedByAuthorizationWarning
          }
          onText="Añadir dirección fiscal"
          offText="Tengo la misma dirección fiscal"
          onChange={handleToggleSameAddressChange}
        />

        {/* Si no hay dirección fiscal => no me la muestres */}
        {fiscalAddressActive && (
          <FiscalAddress
            userIdentityData={userIdentity}
            handleAddressChange={handleFiscalAddressChange}
            handleAddressSelectChange={handleFiscalAddressSelectChange}
            errors={errors}
            disabled={
              mainFormLocked || isOnlyView || blockedByAuthorizationWarning
            }
            countries={countries}
          />
        )}
      </div>
    </>
  );
};

export default ConvenienceTestAccountHolderDataInputs;
